import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { StyledEngineProvider } from '@mui/material';
import reportWebVitals from './reportWebVitals';

import './index.css';
import App from './App';
import store from './redux/store';
import 'react-toastify/dist/ReactToastify.css';
import Wrapper from './components/wrapper/wrapper';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<Provider store={store}>
		<StyledEngineProvider injectFirst>
			<Router>
				<Wrapper>
					<App />
				</Wrapper>
			</Router>
		</StyledEngineProvider>
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
